import { createReactBlockSpec } from "@blocknote/react";
import { InlineSocialLinks } from "./InlineSocialLinks.tsx";
import { SocialLinksBlock } from "./SocialLinksBlock.tsx";

export const SocialLinksBlockSpec = createReactBlockSpec(
  {
    type: "socialLinksBlock",
    propSchema: {
      links: {
        default: "",
      },
      buttonTextColor: {
        default: "",
      },
      buttonBackgroundColor: {
        default: "",
      },
    },
    content: "none",
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { links, buttonTextColor, buttonBackgroundColor },
      },
    }) => {
      const updateBlock = (newProps: Partial<{ links: string }>) => {
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: newProps as any });
      };

      return (
        <SocialLinksBlock
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          blockId={id}
          updateBlock={updateBlock}
          links={links}
        />
      );
    },
    toExternalHTML: ({
      block: {
        props: { links, buttonTextColor, buttonBackgroundColor },
      },
    }) => {
      return (
        <InlineSocialLinks
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          links={links}
        />
      );
    },
  },
);
